import React from 'react';
import Navbar from '../components/sections/Navbar';
import HeroSection from '../components/sections/HeroSection';
import HeritageSection from '../components/sections/HeritageSection';
import InteractiveMap from '../components/sections/InteractiveMap';
import WhatWeDo from '../components/sections/WhatWeDo';
import Footer from '../components/sections/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main id="main-content" tabIndex={-1}>
      <HeroSection />
      <HeritageSection />
      <WhatWeDo />
      <InteractiveMap />
      </main>
      <Footer />
    </div>
  );
}
